import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useCustomer } from "../customer/CustomerContext";

export function OAuthCallbackPage() {
  const { customer, loginWithToken } = useCustomer();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = (params.get("token") || "").trim();
    if (!token) {
      setError("Missing login token from OAuth provider.");
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await loginWithToken(token);
        if (!cancelled) navigate("/account", { replace: true });
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "OAuth login failed.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params, loginWithToken, navigate]);

  if (customer && !error) return <Navigate to="/account" replace />;

  return (
    <article className="page account-page">
      <p className="eyebrow">Customer account</p>
      <h1>Signing you in…</h1>
      {error ? (
        <>
          <p className="model-run-error" role="alert">
            {error}
          </p>
          <p className="account-switch">
            <Link to="/account/login">Back to log in</Link>
          </p>
        </>
      ) : (
        <p className="page-summary">Finishing OAuth sign-in and loading your profile.</p>
      )}
    </article>
  );
}
